/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var RecursiveBestFirstSearchIterator = _interopRequire(__webpack_require__(1));
	
	var Matrix = _interopRequire(__webpack_require__(8));
	
	var Node = _interopRequire(__webpack_require__(10));
	
	window.TEST = {
	    RecursiveBestFirstSearchIterator: RecursiveBestFirstSearchIterator,
	    Matrix: Matrix,
	    Node: Node
	};

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(object, property, receiver) { var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc && desc.writable) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var RecursiveIterator = _interopRequire(__webpack_require__(2));
	
	var RecursiveBestFirstSearchIterator = (function (_RecursiveIterator) {
	    /**
	     * @param {Object|Array} root
	     * @param {Boolean} [ignoreCircular=false]
	     * @param {Number} [maxDeep=100]
	     */
	
	    function RecursiveBestFirstSearchIterator(root, ignoreCircular, maxDeep) {
	        _classCallCheck(this, RecursiveBestFirstSearchIterator);
	
	        _get(Object.getPrototypeOf(RecursiveBestFirstSearchIterator.prototype), "constructor", this).call(this, root, 1, ignoreCircular, maxDeep);
	    }
	
	    _inherits(RecursiveBestFirstSearchIterator, _RecursiveIterator);
	
	    _createClass(RecursiveBestFirstSearchIterator, {
	        getSuccessorsOfNode: {
	            /**
	             * Returns states of child nodes
	             * @param {Object} node
	             * @param {Array} path
	             * @param {Number} deep
	             * @returns {Array<Object>}
	             */
	
	            value: function getSuccessorsOfNode(node, path, deep) {
	                var _this = this;
	
	                return node.getChildren(deep + 1).map(function (child, key) {
	                    return _this.createSuccessor(node, child, key, path.concat(child.title), deep + 1);
	                });
	            }
	        },
	        getNextSuccessor: {
	            /**
	             * @returns {Object|undefined}
	             */
	
	            value: function getNextSuccessor() {
	                var successors = this.successors;
	                var targetEvaluation = Number.POSITIVE_INFINITY;
	                var targetIndex = -1;
	                for (var i = 0, len = successors.length; i < len; i++) {
	                    var successor = successors[i];
	                    var node = successor.node;
	
	                    var nodeEvaluation = node.evaluate();
	                    if (nodeEvaluation < targetEvaluation) {
	                        targetEvaluation = nodeEvaluation;
	                        targetIndex = i;
	                    }
	                }
	                if (targetIndex !== -1) {
	                    return successors.splice(targetIndex, 1)[0];
	                }
	            }
	        }
	    });
	
	    return RecursiveBestFirstSearchIterator;
	})(RecursiveIterator);
	
	module.exports = RecursiveBestFirstSearchIterator;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _toConsumableArray = function (arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	// forked from https://github.com/nervgh/recursive-iterator
	
	var isObject = _interopRequire(__webpack_require__(3));
	
	var getKeys = _interopRequire(__webpack_require__(4));
	
	// PUBLIC PROPERTIES
	var BYPASS_MODE = "bypassMode";
	var IGNORE_CIRCULAR = "ignoreCircular";
	var MAX_DEEP = "maxDeep";
	var CACHE = "cache";
	var SUCCESSORS = "successors";
	
	// PRIVATE PROPERTIES
	var __SUCCESSOR = "__successor";
	
	var EMPTY_SUCCESSOR = {};
	
	var RecursiveIterator = (function () {
	    /**
	     * @param {Object|Array} root
	     * @param {Number} [bypassMode=0]
	     * @param {Boolean} [ignoreCircular=false]
	     * @param {Number} [maxDeep=100]
	     */
	
	    function RecursiveIterator(root) {
	        var bypassMode = arguments[1] === undefined ? 0 : arguments[1];
	        var ignoreCircular = arguments[2] === undefined ? false : arguments[2];
	        var maxDeep = arguments[3] === undefined ? 100 : arguments[3];
	
	        _classCallCheck(this, RecursiveIterator);
	
	        this[BYPASS_MODE] = bypassMode;
	        this[IGNORE_CIRCULAR] = ignoreCircular;
	        this[MAX_DEEP] = maxDeep;
	        this[CACHE] = [];
	        this[SUCCESSORS] = [];
	        this[__SUCCESSOR] = this.createSuccessor(undefined, root);
	        this.__makeIterable();
	    }
	
	    _createClass(RecursiveIterator, {
	        next: {
	            /**
	             * @returns {Object}
	             */
	
	            value: function next() {
	                var _ref = this[__SUCCESSOR] || EMPTY_SUCCESSOR;
	
	                var node = _ref.node;
	                var path = _ref.path;
	                var deep = _ref.deep;
	
	                if (this[MAX_DEEP] > deep) {
	                    if (this.isNode(node)) {
	                        if (this.isCircular(node)) {
	                            if (this[IGNORE_CIRCULAR]) {} else {
	                                throw new Error("Circular reference");
	                            }
	                        } else {
	                            if (this.onStepInto(this[__SUCCESSOR])) {
	                                var _SUCCESSORS;
	
	                                var descriptors = this.getSuccessorsOfNode(node, path, deep);
	                                var method = this[BYPASS_MODE] ? "push" : "unshift";
	                                (_SUCCESSORS = this[SUCCESSORS])[method].apply(_SUCCESSORS, _toConsumableArray(descriptors));
	                                this[CACHE].push(node);
	                            }
	                        }
	                    }
	                }
	
	                var value = this.getNextSuccessor();
	                var done = !value;
	
	                this[__SUCCESSOR] = value;
	
	                if (done) this.destroy();
	
	                return { value: value, done: done };
	            }
	        },
	        destroy: {
	            /**
	             *
	             */
	
	            value: function destroy() {
	                this[SUCCESSORS].length = 0;
	                this[CACHE].length = 0;
	                this[__SUCCESSOR] = null;
	            }
	        },
	        isNode: {
	            /**
	             * @param {*} any
	             * @returns {Boolean}
	             */
	
	            value: function isNode(any) {
	                return isObject(any);
	            }
	        },
	        isLeaf: {
	            /**
	             * @param {*} any
	             * @returns {Boolean}
	             */
	
	            value: function isLeaf(any) {
	                return !this.isNode(any);
	            }
	        },
	        isCircular: {
	            /**
	             * @param {*} any
	             * @returns {Boolean}
	             */
	
	            value: function isCircular(any) {
	                return this[CACHE].indexOf(any) !== -1;
	            }
	        },
	        getNextSuccessor: {
	            /**
	             * @returns {Object|undefined}
	             */
	
	            value: function getNextSuccessor() {
	                return this[SUCCESSORS].shift();
	            }
	        },
	        getSuccessorsOfNode: {
	            /**
	             * Returns states of child nodes
	             * @param {Object} node
	             * @param {Array} path
	             * @param {Number} deep
	             * @returns {Array<Object>}
	             */
	
	            value: function getSuccessorsOfNode(node, path, deep) {
	                var _this = this;
	
	                return getKeys(node).map(function (key) {
	                    return _this.createSuccessor(node, node[key], key, path.concat(key), deep + 1);
	                });
	            }
	        },
	        createSuccessor: {
	            /**
	             * Returns state of node. Calls for each node
	             * @param {Object} [parent]
	             * @param {*} [node]
	             * @param {String} [key]
	             * @param {Array} [path]
	             * @param {Number} [deep]
	             * @returns {Object}
	             */
	
	            value: function createSuccessor(parent, node, key) {
	                var path = arguments[3] === undefined ? [] : arguments[3];
	                var deep = arguments[4] === undefined ? 0 : arguments[4];
	
	                return { parent: parent, node: node, key: key, path: path, deep: deep };
	            }
	        },
	        onStepInto: {
	            /**
	             * Callback
	             * @param {Object} successor
	             * @returns {Boolean}
	             */
	
	            value: function onStepInto(successor) {
	                return true;
	            }
	        },
	        __makeIterable: {
	            /**
	             * Only for es6
	             * @private
	             */
	
	            value: function __makeIterable() {
	                var _this = this;
	
	                try {
	                    this[Symbol.iterator] = function () {
	                        return _this;
	                    };
	                } catch (e) {}
	            }
	        }
	    });
	
	    return RecursiveIterator;
	})();
	
	module.exports = RecursiveIterator;
	
	// skip

/***/ },
/* 3 */
/***/ function(module, exports) {

	
	
	/**
	 * @param {*} any
	 * @returns {Boolean}
	 */
	"use strict";
	
	module.exports = function (any) {
	  return any !== null && typeof any === "object";
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var isArray = _interopRequire(__webpack_require__(5));
	
	var isArrayLike = _interopRequire(__webpack_require__(6));
	
	var floor = Math.floor;
	var keys = Object.keys;
	
	/**
	 * @param {Object|Array} object
	 * @returns {Array<String>}
	 */
	
	module.exports = function (object) {
	    var keys_ = keys(object);
	    if (isArray(object)) {} else if (isArrayLike(object)) {
	        // only integer values
	        keys_ = keys_.filter(function (key) {
	            return floor(Number(key)) == key;
	        });
	        // skip sort
	    } else {
	        // sort
	        keys_ = keys_.sort();
	    }
	    return keys_;
	};
	
	// skip sort

/***/ },
/* 5 */
/***/ function(module, exports) {

	
	
	/**
	 * @param {*} any
	 * @returns {Boolean}
	 */
	"use strict";
	
	module.exports = Array.isArray;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var isObject = _interopRequire(__webpack_require__(3));
	
	var isGlobalObject = _interopRequire(__webpack_require__(7));
	
	/**
	 * @param {*} any
	 * @returns {Boolean}
	 */
	
	module.exports = function (any) {
	    if (!isObject(any)) return false;
	    if (isGlobalObject(any)) return false;
	    if (!("length" in any)) return false;
	    var length = any.length;
	    if (length === 0) return true;
	    return length - 1 in any;
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	var GLOBAL_OBJECT = new Function("return this")();
	
	/**
	 * @param {*} any
	 * @returns {Boolean}
	 */
	
	module.exports = function (any) {
	  return any === GLOBAL_OBJECT;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var Vector2 = _interopRequire(__webpack_require__(9));
	
	var __PRIVATE = "__private";
	
	var Matrix = (function () {
	    /**
	     * @param {Array.<Array>} matrix
	     */
	
	    function Matrix() {
	        var matrix = arguments[0] === undefined ? [[]] : arguments[0];
	
	        _classCallCheck(this, Matrix);
	
	        this[__PRIVATE] = matrix;
	    }
	
	    _createClass(Matrix, {
	        getSizes: {
	            /**
	             * @returns {Object}
	             */
	
	            value: function getSizes() {
	                var matrix = this[__PRIVATE];
	                return {
	                    height: matrix.length,
	                    width: matrix[0].length
	                };
	            }
	        },
	        forEachCell: {
	            /**
	             * @param {Function} callback
	             */
	
	            value: function forEachCell(callback) {
	                var matrix = this[__PRIVATE];
	
	                var _getSizes = this.getSizes();
	
	                var width = _getSizes.width;
	                var height = _getSizes.height;
	
	                for (var i = 0; i < height; i++) {
	                    for (var j = 0; j < width; j++) {
	                        var cell = matrix[i][j];
	                        var vector = new Vector2(j, i);
	                        callback(cell, vector);
	                    }
	                }
	            }
	        },
	        findCellVector: {
	            /**
	             * @param {Function} isTargetCell
	             * @returns {Vector2}
	             * @private
	             */
	
	            value: function findCellVector(isTargetCell) {
	                var matrix = this[__PRIVATE];
	
	                var _getSizes = this.getSizes();
	
	                var width = _getSizes.width;
	                var height = _getSizes.height;
	
	                var vector = new Vector2();
	                for (var i = 0; i < height; i++) {
	                    for (var j = 0; j < width; j++) {
	                        var cell = matrix[i][j];
	                        if (isTargetCell(cell)) {
	                            vector[0] = j;
	                            vector[1] = i;
	                            return vector;
	                        }
	                    }
	                }
	                return vector;
	            }
	        },
	        swapCells: {
	            /**
	             * @param {Vector2} vector1
	             * @param {Vector2} vector2
	             */
	
	            value: function swapCells(vector1, vector2) {
	                var matrix = this[__PRIVATE];
	                var cell1 = matrix[vector1[1]][vector1[0]];
	                var cell2 = matrix[vector2[1]][vector2[0]];
	                matrix[vector1[1]][vector1[0]] = cell2;
	                matrix[vector2[1]][vector2[0]] = cell1;
	            }
	        },
	        clone: {
	            /**
	             * @returns {Matrix}
	             */
	
	            value: function clone() {
	                var matrix = this[__PRIVATE];
	
	                var _getSizes = this.getSizes();
	
	                var height = _getSizes.height;
	
	                var newMatrix = new Array(height);
	                for (var i = 0; i < height; i++) {
	                    newMatrix[i] = matrix[i].slice();
	                }
	                return new Matrix(newMatrix);
	            }
	        }
	    });
	
	    return Matrix;
	})();
	
	module.exports = Matrix;

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var Vector2 = (function () {
	    /**
	     * @param {Number} x
	     * @param {Number} y
	     */
	
	    function Vector2() {
	        var x = arguments[0] === undefined ? 0 : arguments[0];
	        var y = arguments[1] === undefined ? 0 : arguments[1];
	
	        _classCallCheck(this, Vector2);
	
	        this[0] = x;
	        this[1] = y;
	    }
	
	    _createClass(Vector2, {
	        clone: {
	            /**
	             * @returns {Vector2}
	             */
	
	            value: function clone() {
	                return new Vector2(this[0], this[1]);
	            }
	        }
	    }, {
	        distanceManhattan: {
	            /**
	             * @see http://habrahabr.ru/post/101338/
	             * @param {Vector2} v1
	             * @param {Vector2} v2
	             * @returns {Number}
	             */
	
	            value: function distanceManhattan(v1, v2) {
	                return Math.abs(v1[0] - v2[0]) + Math.abs(v1[1] - v2[1]);
	            }
	        }
	    });
	
	    return Vector2;
	})();
	
	module.exports = Vector2;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var Matrix = _interopRequire(__webpack_require__(8));
	
	var Vector2 = _interopRequire(__webpack_require__(9));
	
	var __COST_OF_PATH = "__costOfPath";
	var __COST_TO_GOAL = "__costToGoal";
	var __CHILDREN = "__children";
	var __MATRIX = "__matrix";
	var __TITLE = "__title";
	
	var counter = 0;
	
	var Node = (function () {
	    /**
	     * @param {String} title
	     * @param {Number} costOfPath
	     * @param {Object} matrix
	     * @param {Object} [parentNode]
	     */
	
	    function Node(title, costOfPath, matrix, parentNode) {
	        _classCallCheck(this, Node);
	
	        this.setTitle(title);
	        this.setCostOfPath(costOfPath);
	        this[__MATRIX] = matrix;
	        this[__COST_TO_GOAL] = undefined;
	        this[__CHILDREN] = undefined;
	        this.parentNode = parentNode;
	    }
	
	    _createClass(Node, {
	        getTitle: {
	            /**
	             * @returns {String}
	             */
	
	            value: function getTitle() {
	                return this[__TITLE];
	            }
	        },
	        setTitle: {
	            /**
	             * @param {String} title
	             */
	
	            value: function setTitle() {
	                var title = arguments[0] === undefined ? "" : arguments[0];
	
	                this[__TITLE] = title;
	            }
	        },
	        getCostOfPath: {
	            /**
	             * g()
	             * @returns {Number}
	             */
	
	            value: function getCostOfPath() {
	                return this[__COST_OF_PATH];
	            }
	        },
	        setCostOfPath: {
	            /**
	             * @param {Number} cost
	             */
	
	            value: function setCostOfPath() {
	                var cost = arguments[0] === undefined ? 0 : arguments[0];
	
	                return this[__COST_OF_PATH] = cost;
	            }
	        },
	        getCostToGoal: {
	            /**
	             * h()
	             * @returns {Number}
	             */
	
	            value: function getCostToGoal() {
	                if (isUndefined(this[__COST_TO_GOAL])) {
	                    this[__COST_TO_GOAL] = this.__getCostToGoal();
	                }
	                return this[__COST_TO_GOAL];
	            }
	        },
	        evaluate: {
	            /**
	             * f() => g() + h()
	             * @returns {*}
	             */
	
	            value: function evaluate() {
	                return this.getCostOfPath() + this.getCostToGoal();
	            }
	        },
	        getChildren: {
	            /**
	             * @param {Number} costOfPath
	             * @returns {Array.<Node>}
	             */
	
	            value: function getChildren() {
	                var costOfPath = arguments[0] === undefined ? 0 : arguments[0];
	
	                if (isUndefined(this[__CHILDREN])) {
	                    this[__CHILDREN] = this.__getChildren(costOfPath);
	                }
	                return this[__CHILDREN];
	            }
	        },
	        __getCostToGoal: {
	            /**
	             * @returns {Number}
	             */
	
	            value: function __getCostToGoal() {
	                var matrix = this[__MATRIX];
	
	                var _matrix$getSizes = matrix.getSizes();
	
	                var width = _matrix$getSizes.width;
	                var height = _matrix$getSizes.height;
	
	                var distances = new Array(width * height);
	                var counter = 0;
	                matrix.forEachCell(function (cell, currentVector) {
	                    if (isNumber(cell)) {
	                        var x = (cell - 1) % width;
	                        var y = Math.ceil(cell / height) - 1;
	                        var targetVector = new Vector2(x, y);
	                        var distance = Vector2.distanceManhattan(targetVector, currentVector);
	                        distances[counter] = distance;
	                        counter += 1;
	                    }
	                });
	                var sum = distances.reduce(function (sum, item) {
	                    return sum + item;
	                }, 0);
	                return sum;
	            }
	        },
	        __getChildren: {
	            /**
	             * @param {Number} costOfPath
	             * @returns {Array.<Node>}
	             * @private
	             */
	
	            value: function __getChildren(costOfPath) {
	                var matrix = this[__MATRIX];
	
	                var _matrix$getSizes = matrix.getSizes();
	
	                var width = _matrix$getSizes.width;
	                var height = _matrix$getSizes.height;
	
	                var vector = matrix.findCellVector(function (cell) {
	                    return !isNumber(cell);
	                });
	                var children = [];
	                if (vector[0] !== 0) {
	                    var matrixClone = matrix.clone();
	                    var vectorClone = vector.clone();
	                    vectorClone[0] -= 1;
	                    matrixClone.swapCells(vector, vectorClone);
	                    children.push(new Node(String(counter++), costOfPath, matrixClone, this));
	                }
	                if (vector[0] !== width - 1) {
	                    var matrixClone = matrix.clone();
	                    var vectorClone = vector.clone();
	                    vectorClone[0] += 1;
	                    matrixClone.swapCells(vector, vectorClone);
	                    children.push(new Node(String(counter++), costOfPath, matrixClone, this));
	                }
	                if (vector[1] !== 0) {
	                    var matrixClone = matrix.clone();
	                    var vectorClone = vector.clone();
	                    vectorClone[1] -= 1;
	                    matrixClone.swapCells(vector, vectorClone);
	                    children.push(new Node(String(counter++), costOfPath, matrixClone, this));
	                }
	                if (vector[1] !== height - 1) {
	                    var matrixClone = matrix.clone();
	                    var vectorClone = vector.clone();
	                    vectorClone[1] += 1;
	                    matrixClone.swapCells(vector, vectorClone);
	                    children.push(new Node(String(counter++), costOfPath, matrixClone, this));
	                }
	                return children;
	            }
	        }
	    });
	
	    return Node;
	})();
	
	module.exports = Node;
	
	/**
	 * @param {*} any
	 * @returns {Boolean}
	 */
	function isNumber(any) {
	    return typeof any === "number";
	}
	/**
	 * @param {*} any
	 * @returns {Boolean}
	 */
	function isUndefined(any) {
	    return any === undefined;
	}

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/